import { LineChevronDownSmall } from '@qr-front/icons/line-chevron-down-small'
import { LineGlobe } from '@qr-front/icons/line-globe'
import { cn } from '@qr-front/ui/utils'
import { ReactNode, useMemo } from 'react'

import type { TLanguageSelectDesktopProps } from './LanguageSelectDesktop'

export const LanguageSelectDesktopTrigger = ({
	onPointerDown,
	languageList,
	showLabelAs = 'code',
	lang,
	locale,
	Container,
	ValueWrapper,
	triggerClassNames,
}: TLanguageSelectDesktopProps & {
	onPointerDown?: () => void
	Container?: ({ children }: { children: ReactNode }) => ReactNode
	ValueWrapper?: ({ children }: { children: ReactNode }) => ReactNode
	triggerClassNames?: string
}) => {
	const labelToShow = useMemo(() => {
		return languageList.find((lang) => lang.code === locale)
	}, [languageList, locale])

	const value = (
		<span className="type-button-small mr-1 font-normal">
			{showLabelAs === 'name' ? labelToShow?.name : locale.toUpperCase()}
			{lang}
		</span>
	)

	const _Container = Container || 'button'
	const _ValueWrapper = ValueWrapper || 'span'

	return (
		<_Container
			onPointerDown={() => {
				onPointerDown?.()
			}}
			className={cn(
				'flex items-center justify-center p-2 transition-colors [&[data-state=open]>svg]:rotate-180',
				triggerClassNames,
			)}
		>
			<LineGlobe className="mr-2" />
			<_ValueWrapper>{value}</_ValueWrapper>
			<LineChevronDownSmall
				className="h-4 w-4 transition-transform duration-200"
				aria-label="Arrow down icon"
			/>
		</_Container>
	)
}
